import { Node } from '@tiptap/core';
import { Editor } from '@tiptap/vue-2';

// Extensions
// NOTE All the imports below are used to replace StarterKit https://www.tiptap.dev/api/extensions/starter-kit/
// import StarterKit from '@tiptap/starter-kit';
// StarterKit is a shortcut for all these but it also imports "CodeBlock" extension, which causes bugs on Chrome < 62
import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Document from '@tiptap/extension-document';
import Dropcursor from '@tiptap/extension-dropcursor';
import Gapcursor from '@tiptap/extension-gapcursor';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import Highlight from '@tiptap/extension-highlight';
import History from '@tiptap/extension-history';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import Image from '@tiptap/extension-image';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Strike from '@tiptap/extension-strike';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';
import Text from '@tiptap/extension-text';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';

// StarterKit without "CodeBlock" which is not compatible with Chrome 60
export const CustomStarterKit = [
  Highlight,
  Link,
  TaskItem,
  TaskList,

  Blockquote,
  Bold,
  BulletList,
  Document,
  Dropcursor,
  Gapcursor,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Image,
  Italic,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  Text,
  TextStyle,
  // Apparently, underline must be after text, bold and italic to work with <strong> and <em>
  Underline,
];

// Allow having single line editors
// https://github.com/ueberdosis/tiptap/issues/96
// Replaces the 'Document' extension in TipTap editor in order to have a single line content
export const OneLineDoc = Node.create({
  name: 'doc',
  topNode: true,
  content: 'block',
});

/** TipTap Editor usable anywhere in the app */
export const utilsTiptapEditor = new Editor({
  content: '',
  extensions: CustomStarterKit,
});

/**
 * Find the tasks of all the task lists in a tiptap editor's content
 * @param  {Object} content   tiptap-understandable content
 * @return {Object}           { n: number of completed tasks, total: number of tasks }
 */
export function getTasksFromTiptapContent(content) {
  let tiptapContent = '';
  // NOTE Prior to v1.7.39, tiptap content was stored in the DB as a JSON object, hence the JSON parsing.
  // From 1.7.39 onwards, HTML is prefered as it makes it easier to work with in the back-end.
  // Check if the content is a JSON object or a string.
  try {
    tiptapContent = JSON.parse(content);
  } catch (e) {
    tiptapContent = content;
  }

  if (!(tiptapContent instanceof Object)) {
    // Content was an HTML string (or a simple string). Use a tiptap editor to convert it to an object.
    utilsTiptapEditor.commands.setContent(tiptapContent);
    tiptapContent = utilsTiptapEditor.getJSON();
  }

  if (tiptapContent.content instanceof Array) {
    let totalTasks = 0;
    let completedTasks = 0;
    const tasklists = tiptapContent.content.filter(c => c.type === 'taskList');
    tasklists.forEach((list) => {
      const items = (list.content || []).filter(item => item.type === 'taskItem');
      totalTasks += items.length;
      completedTasks += items.filter(item => item.attrs.checked).length;
    });
    if (totalTasks === 0) {
      return null;
    }
    return { n: completedTasks, total: totalTasks };
  }
  return null;
}
